import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import theme from "@config/theme";
import { Container, Row, Col } from "react-grid-system";

const Quickstart = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "Quickstart", url: "/quickstart" },
            ]}
          />
          <h1>Quickstart</h1>
          <p>
            Tutorials to help you get up and running with Blues hardware fast.
          </p>
        </Col>
      </Row>

      <hr />
      <h2>Starter Kits</h2>

      <div className="card-container">
        <div className="card">
          <h3>Cell+WiFi Starter Kit</h3>
          <img alt="" src={ImgSrc("/images/quickstart/steps/app-step.png")} />
          <TrackedLink className="btn" href="/quickstart/cellwifi-quickstart">
            Get Started
          </TrackedLink>
          <TrackedLink href="https://shop.blues.com/products/blues-global-starter-kit">
            Buy Now
          </TrackedLink>
        </div>

        <div className="card">
          <h3>LoRaWAN Starter Kit</h3>
          <img
            alt=""
            src={ImgSrc(
              "/images/hardware/starter-kits/lorawan-starter-kit-small.jpg",
            )}
          />
          <TrackedLink className="btn" href="/quickstart/lorawan-quickstart">
            Get Started
          </TrackedLink>
          <TrackedLink href="https://shop.blues.com/products/blues-starter-kit-lorawan">
            Buy Now
          </TrackedLink>
        </div>

        <div className="card">
          <h3>Starnote Starter Kit</h3>
          <img
            alt=""
            src={ImgSrc("/images/hardware/starter-kits/starnote-kit.png")}
          />
          <TrackedLink className="btn" href="/quickstart/starnote-quickstart">
            Get Started
          </TrackedLink>
          <TrackedLink href="https://shop.blues.com/products/starnote-starter-kit">
            Buy Now
          </TrackedLink>
        </div>

        <div className="card">
          <h3>Wireless for PLC</h3>
          <img
            alt=""
            src={ImgSrc(
              "/images/hardware/opta-expansion/opta-expansion-front.png",
            )}
          />
          <TrackedLink
            className="btn"
            href="/quickstart/wireless-for-plc-quickstart"
          >
            Get Started
          </TrackedLink>
          <TrackedLink href="https://shop.blues.com/products/wireless-for-plc">
            Buy Now
          </TrackedLink>
        </div>
      </div>

      <hr />
      <h2>Hardware</h2>

      <div className="card-container">
        <div className="card">
          <h3>Notecard</h3>
          <img
            alt=""
            src={ImgSrc("/images/hardware/notecard/WBGLW-Front.png")}
          />
          <TrackedLink
            className="btn"
            href="/quickstart/notecard-quickstart"
            data-test-id="notecard-quickstart-link"
          >
            Get Started
          </TrackedLink>
          <TrackedLink href="https://shop.blues.com/collections/notecard">
            Buy Now
          </TrackedLink>
        </div>

        <div className="card">
          <h3>Swan</h3>
          <img alt="" src={ImgSrc("/images/quickstart/steps/mcu-step.png")} />
          <TrackedLink className="btn" href="/quickstart/swan-quickstart">
            Get Started
          </TrackedLink>
          <TrackedLink href="https://shop.blues.com/collections/swan/products/swan">
            Buy Now
          </TrackedLink>
        </div>

        <div className="card">
          <h3>Starnote</h3>
          <img
            alt=""
            src={ImgSrc("/images/hardware/starter-kits/temp-starnote-kit.png")}
          />
          <TrackedLink className="btn" href="/quickstart/starnote-quickstart">
            Get Started
          </TrackedLink>
          <TrackedLink href="https://shop.blues.com/products/starnote">
            Buy Now
          </TrackedLink>
        </div>

        <div className="card">
          <h3>Notecard Simulator</h3>
          <img alt="" src={ImgSrc("/images/quickstart/simulator.svg")} />
          <TrackedLink
            className="btn"
            href="/quickstart/notecard-quickstart/notecard-simulator/"
          >
            Get Started
          </TrackedLink>
          <TrackedLink href="/" style={{ visibility: "hidden" }}>
            Hidden
          </TrackedLink>
        </div>

        <div className="card">
          <h3>Sparrow Development Kit</h3>
          <img alt="" src={ImgSrc("/images/quickstart/sparrow/hardware.png")} />
          <TrackedLink className="btn" href="/quickstart/sparrow-quickstart/">
            Get Started
          </TrackedLink>
          <TrackedLink href="/" style={{ visibility: "hidden" }}>
            Hidden
          </TrackedLink>
        </div>
      </div>

      <style jsx>{`
        h2 {
          margin-bottom: 2rem !important;
        }

        .card-container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 1rem;
        }
        .card-container {
          grid-template-columns: repeat(3, 1fr);
        }
        @media screen and (max-width: ${theme.breakpoints.md}px) {
          .card-container {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media screen and (max-width: ${theme.breakpoints.sm}px) {
          .card-container {
            grid-template-columns: 1fr;
          }
        }
        .card-container:first-of-type {
          margin-bottom: 10rem;
        }

        .card {
          border: 1px solid ${theme.colors.lightGray};
          border-radius: 10px;
          padding: 1rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
        }
        .card h3 {
          margin: 0 0 1rem 0;
        }
        :global(.card .btn) {
          margin: 1rem 0;
        }
        .card img {
          flex: 1;
          max-height: 150px;
        }
      `}</style>
    </Container>
  </>
);

export default Quickstart;
